export const axoVersionsKeys = {
  root: () =>
    ({
      service: 'ace',
      scope: 'axo-versions',
    }) as const,

  application: (loanApplicationID?: string) =>
    ({
      ...axoVersionsKeys.root(),
      loanApplicationID,
    }) as const,
};
